import React from "react";
import { Alert, Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";
import {
  Document,
  TemplateFieldV2,
} from "../../../../docuclipper/DocuclipperTypes";
import { ReduxState } from "../../../../redux";
import {
  fetchPage,
  fieldSectionSetExpanded,
  setCanvasMode,
  setDragMode,
  zoomStageIn,
  zoomStageOut,
} from "../../../../redux/reducers/TemplateField";
import { useIsAdmin } from "../../../../utils/auth";
import ToolBar from "../Toolbar";
import { CanvasModeBanner } from "./CanvasModeBanner";
import { DrawRectangleConnected } from "./DrawRectangleV2";
import { ExtractedDataTable } from "./ExtractedDataTable";
import { ExtractedDataText } from "./ExtractedDataText";
import { FieldList } from "./FieldList";
import FieldSection from "./FieldSection";
import { FieldTypeSelectorText } from "./FieldTypeSelector";
import GoToPage from "./GoToPage";
import { LocationSelector } from "./LocationSelector";
import { NameSelector } from "./NameSelector";
import { PageSelector } from "./PageSelector";
import PaginationWrapper from "./PaginationWrapper";
import TemplateAdminOptions from "./QboOptions/TemplateAdminOptions";
import { isFieldInPage } from "./RegionsUtils";
import { SaveTemplate } from "./SaveTemplate";
import { TableConfigSelector } from "./TableConfigSelector";
import { Thumbnails } from "./Thumbnails";
// import useWindowDimensions from "../../../../custom-hooks/useWindowDimensions";
import { ToolTypeSelector } from "./ToolTypeSelector";
import { VariableFields } from "./VariableFields";

type Props = {};

export const Regions: React.SFC<Props> = () => {
  const dispatch = useDispatch();
  const [overlayClasses, setOverlayClasses] = React.useState("");
  const [childrenClasses, setChildrenClasses] = React.useState("");

  const { isAdmin } = useIsAdmin();
  const { template } = useSelector((state: ReduxState) => state.TemplateField);

  // const { height, width } = useWindowDimensions();
  const {
    canvasMode,

    page,
    stage,
    selectedFieldId,
    templateFields,
    fieldSection,
  } = useSelector((state: ReduxState) => state.TemplateField);
  // const { token } = useSelector((state: ReduxState) => state.Auth);
  // const showExtractAll =
  //   token && token.permissions && token.permissions.includes("READ_DB_TABLES");
  const { files } = useSelector((state: ReduxState) => state.Files);
  let document: Document | undefined;
  if (files.length > 0) {
    document = files[0].document;
  }
  let pageElem: JSX.Element | null = null;
  if (page && page.loading) {
    pageElem = <ClipLoader loading={true} />;
  } else if (page && page.error) {
    pageElem = <Alert variant="danger">{page.error}</Alert>;
  } else if (document && page && page.page) {
    pageElem = (
      <>
        <div
          // onClick={() => console.log("clicked on children")}
          style={{ position: "relative", backgroundColor: "white" }}
          className={`${childrenClasses} draw-rectangle`} /*style={{ height: 1200 }}*/
        >
          <DrawRectangleConnected />
        </div>
      </>
    );
  }

  React.useEffect(() => {
    if (["selectWords"].includes(canvasMode)) {
      setOverlayClasses("overlay fadeIn");
      setChildrenClasses("z99999");
    } else {
      setOverlayClasses("overlay fadeOut");
      window.document.body.classList.remove("modal-open");
      setChildrenClasses("z1");
    }
  }, [canvasMode]);

  React.useEffect(() => {
    dispatch(fetchPage({ pageNumber: 0 }));
  }, [dispatch, document]);

  let fieldInPage = false;
  const maybeField = templateFields.filter((tf) => tf.id === selectedFieldId);
  let field: TemplateFieldV2 | null = null;
  if (document && page.page && maybeField.length > 0) {
    field = maybeField[0];

    if (field) {
      fieldInPage = isFieldInPage({
        field,
        currentPage: page.page.pageNumber,
        document,
      });
    }
  }

  const documentSectionWidth = canvasMode === "documentOnly" ? 10 : 7;
  const fieldPreviewHeight = canvasMode === "rectangles" ? "300px" : "";
  return (
    <>
      <div style={{ display: "flex", flexFlow: "column", height: "100%" }}>
        <div>
          <Row style={{ flexGrow: 1 }}>
            <div
              className={overlayClasses}
              onClick={() =>
                dispatch(setCanvasMode({ canvasMode: "rectangles" }))
              }
            />

            <Col className="thumbnails" md="2">
              <Thumbnails />
            </Col>
            <Col
              xs={documentSectionWidth}
              sm={documentSectionWidth}
              md={documentSectionWidth}
              lg={documentSectionWidth}
              xl={documentSectionWidth}
            >
              <CanvasModeBanner />
              <Row className="justify-content-around mb-2">
                {document && (
                  <>
                    <PaginationWrapper
                      selectedPage={page.page ? page.page.pageNumber : 0}
                      numPages={document.numPages}
                    />
                    <div>
                      <GoToPage numPages={document.numPages} />
                    </div>
                  </>
                )}

                <ToolBar
                  dragModeEnabled={stage ? stage.dragModeEnabled : false}
                  toolType={"ocr"}
                  onZoomIn={() => dispatch(zoomStageIn({}))}
                  onZoomOut={() => dispatch(zoomStageOut({}))}
                  onDragSelected={() =>
                    dispatch(setDragMode({ dragModeEnabled: true }))
                  }
                  onSelectSelected={() =>
                    dispatch(setDragMode({ dragModeEnabled: false }))
                  }
                  onOcrSelected={() => null}
                  onHandwritingSelected={() => null}
                  onTablesSelected={() => null}
                  toolbarFn={() => null}
                ></ToolBar>
              </Row>
              {pageElem}
            </Col>
            {canvasMode !== "documentOnly" && (
              <Col
                style={{ paddingLeft: 0 }}
                xs="3"
                sm="3"
                md="3"
                lg="3"
                xl="3"
              >
                <>
                  <SaveTemplate />
                  {/* {showExtractAll && <DetectAllFields />} */}

                  {isAdmin &&
                    !(
                      template &&
                      template.template &&
                      template.template.id !== undefined
                    ) && <TemplateAdminOptions />}
                  <div className="my-2">
                    <FieldList />
                  </div>
                  {field && !fieldInPage && (
                    <Alert variant="danger">Field not in page</Alert>
                  )}

                  {field && fieldInPage && (
                    <>
                      <div
                        style={{ height: fieldPreviewHeight, display: "flex" }}
                      >
                        {["ocr", "handwriting", "checkbox"].includes(
                          field.toolType
                        ) && <ExtractedDataText />}
                        {["tables", "ocrtables"].includes(field.toolType) && (
                          <ExtractedDataTable />
                        )}
                      </div>

                      {canvasMode === "rectangles" && (
                        <>
                          <FieldSection
                            expanded={fieldSection.fieldConfig.expanded}
                            hasError={fieldSection.fieldConfig.hasError}
                            setExpanded={(isExpanded) =>
                              dispatch(
                                fieldSectionSetExpanded({
                                  name: "fieldConfig",
                                  expanded: isExpanded,
                                })
                              )
                            }
                            heading="Field config"
                          >
                            <Form.Label>
                              <strong>Field name</strong>
                            </Form.Label>
                            <NameSelector />
                            <div className="mt-2">
                              <div>
                                <Form.Label>
                                  <strong>Field type</strong>
                                </Form.Label>
                              </div>
                              <ToolTypeSelector />
                            </div>
                            {["ocr", "handwriting"].includes(
                              field.toolType
                            ) && (
                              <div className="mt-2">
                                <div>
                                  <Form.Label>
                                    <strong>Field format</strong>
                                  </Form.Label>
                                </div>
                                <FieldTypeSelectorText />
                              </div>
                            )}
                          </FieldSection>

                          {["tables", "ocrtables"].includes(field.toolType) && (
                            <FieldSection
                              expanded={fieldSection.tableConfig.expanded}
                              hasError={fieldSection.tableConfig.hasError}
                              setExpanded={(isExpanded) =>
                                dispatch(
                                  fieldSectionSetExpanded({
                                    name: "tableConfig",
                                    expanded: isExpanded,
                                  })
                                )
                              }
                              heading="Table Configuration"
                              renderHelp={() => (
                                <p>
                                  Configure a table field. Specify the number of
                                  columns and header rows. Mark where the
                                  columns start by dragging the blue lines.
                                </p>
                              )}
                            >
                              <TableConfigSelector />
                            </FieldSection>
                          )}

                          <FieldSection
                            expanded={fieldSection.fieldLocation.expanded}
                            hasError={fieldSection.fieldLocation.hasError}
                            setExpanded={(isExpanded) =>
                              dispatch(
                                fieldSectionSetExpanded({
                                  name: "fieldLocation",
                                  expanded: isExpanded,
                                })
                              )
                            }
                            heading="Field Location"
                            renderHelp={() => (
                              <>
                                {" "}
                                <p>
                                  Fixed-position fields always have the same
                                  location in the page. Examples include
                                  standard tax forms.
                                </p>
                                <p>
                                  Variable-position fields can have different
                                  positions in the page. Examples include bank
                                  statement transactions.
                                </p>
                              </>
                            )}
                          >
                            <LocationSelector />
                          </FieldSection>

                          {field.locationType === "variable" && (
                            <FieldSection
                              expanded={fieldSection.variableLocation.expanded}
                              hasError={fieldSection.variableLocation.hasError}
                              setExpanded={(isExpanded) =>
                                dispatch(
                                  fieldSectionSetExpanded({
                                    name: "variableLocation",
                                    expanded: isExpanded,
                                  })
                                )
                              }
                              heading="Variable Field Configuration"
                            >
                              <VariableFields />
                            </FieldSection>
                          )}
                        </>
                      )}
                    </>
                  )}
                  {field && canvasMode === "rectangles" && (
                    <FieldSection
                      expanded={fieldSection.pageConfig.expanded}
                      hasError={fieldSection.pageConfig.hasError}
                      setExpanded={(isExpanded) =>
                        dispatch(
                          fieldSectionSetExpanded({
                            name: "pageConfig",
                            expanded: isExpanded,
                          })
                        )
                      }
                      heading="Page Configuration"
                      renderHelp={() => (
                        <p>
                          Specify if the field is present in this page only, all
                          the pages or a custom range of pages.
                        </p>
                      )}
                    >
                      <PageSelector />
                    </FieldSection>
                    // <Card>
                    //   <Card.Header>
                    //     <div className="h5">Page Configuration</div>
                    //   </Card.Header>
                    //   <Card.Body>
                    //     <PageSelector />
                    //   </Card.Body>
                    // </Card>
                  )}
                </>
              </Col>
            )}
          </Row>
        </div>
      </div>
    </>
  );
};

export default Regions;
